export default __webpack_public_path__ + "static/media/location.3a1af43c.svg";